// 勤怠マイページ共通の日付・時刻ユーティリティ（純関数のみ・副作用なし）。
// これまで各画面にコピーされていた pad2/WD/ymd/fmt/diffMin/fmtMin 等をここに集約する。
// 挙動は既存実装と一致させてある（移行しても表示は変わらない）。

// ── 期間の業務ルール（複数画面が同じ値を見る。各画面に直書きしないこと） ──

// 会社設立月。給与明細の月グリッドの下限。社員側(PayslipPage)と経営者側(PayslipAdminPage)が
// 同じ値を見る。以前は両ファイルに「同値に保つ」というコメント付きで二重定義されていた。
export const FOUNDED_YM = "202311"; // 株式会社Guluu = 2023年11月 法人設立

// 給与明細で当月より先に出す月数（枠を先行して用意するため）。
export const MONTHS_AHEAD = 2;

// 履歴カレンダー（休み/残業/時間訂正）で遡れる下限の月数。事後申請のため過去も選べる。
export const HISTORY_MONTHS_BACK = 12;

// 曜日（0=日 〜 6=土）。
export const WD = ["日", "月", "火", "水", "木", "金", "土"];

// 数値を2桁ゼロ埋め（例: 3 → "03"）。
export const pad2 = (n) => String(n).padStart(2, "0");

// Date → "YYYY-MM-DD"。
export const ymd = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

// (y, m, d) → "YYYY-MM-DD"（m/d は1始まり）。
export const ymdParts = (y, m, d) => `${y}-${pad2(m)}-${pad2(d)}`;

// 本日の "YYYY-MM-DD"。
export const todayYmd = () => ymd(new Date());

// 現在から n ヶ月前の "YYYY-MM"（日付ピッカーで戻れる下限。事後申請のため過去も選べる）。
export const monthsAgoYm = (n) => {
  const d = new Date();
  d.setMonth(d.getMonth() - n);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}`;
};

// "YYYY-MM-DD" → 曜日文字（"日"〜"土"）。
export const weekdayJa = (ds) => {
  const [y, m, d] = String(ds).split("-").map(Number);
  return WD[new Date(y, m - 1, d).getDay()];
};

// "YYYY-MM-DD" → "M月D日(曜)"。
export const formatJaDate = (ds) => {
  const [y, m, d] = String(ds).split("-").map(Number);
  return `${m}月${d}日(${WD[new Date(y, m - 1, d).getDay()]})`;
};

// ISO/日時文字列 → "HH:MM"（不正な値は ""）。
export const hm = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

// "HH:MM"×2 → 分差（終了が開始以前なら0。深夜またぎ非対応＝同日内）。
export const diffMin = (start, end) => {
  if (!start || !end) return 0;
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  return (eh * 60 + em) - (sh * 60 + sm);
};

// 分 → "H時間M分"（0以下は "-"、0分は時間のみ）。
export const fmtMin = (m) => {
  if (!m || m <= 0) return "-";
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h > 0) return mm > 0 ? `${h}時間${mm}分` : `${h}時間`;
  return `${mm}分`;
};

// 月カレンダーのセル配列（7列グリッド用）。先頭に前月ぶんの空白(null)を詰め、続けて 1〜末日。
// year=西暦, month=1-12。例（2026年7月＝1日が水）: [null,null,null,1,2,…,31]。
export const buildMonthCells = (year, month) => {
  const firstWeekday = new Date(year, month - 1, 1).getDay(); // 0=日
  const lastDay = new Date(year, month, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstWeekday; i += 1) cells.push(null);
  for (let d = 1; d <= lastDay; d += 1) cells.push(d);
  return cells;
};
